import React, { useContext } from 'react';
import { AppDataContext } from 'contexts/appData';
import clsx from 'clsx';
import { usePaymentContext } from '../PaymentProvider';
import Checkbox from '../../../../common/form/Checkbox';
import { PaymentMethodsEnum } from '../helpers';

import { ReactComponent as BogIcon } from 'resources/img/icons/bog_bank.svg';
import { ReactComponent as TbcBankIcon } from 'resources/img/icons/tbc_bank1.svg';
import { ReactComponent as OtherBankIcon } from 'resources/img/icons/other_bank.svg';

import { ReactComponent as AmexIcon } from 'resources/img/icons/amex1.svg';
import { ReactComponent as VisaIcon } from 'resources/img/icons/visa1.svg';
import { ReactComponent as MasterCardIcon } from 'resources/img/icons/master_card1.svg';

export const PaymentCardGroup = ({ onClick, isSelected, method, methods, saveCard, onSaveCard }) => {
  const { langs } = useContext(AppDataContext);
  const { setSelectedPaymentMethod, selectedPaymentMethod } = usePaymentContext();

  return (
    <div className="mb-8px cursor-pointer">
      <div
        className={clsx('custom-control custom-radio border-radius-md px-16px py-24px px-md-24px m-auto', {
          'active-without-hover': isSelected,
        })}
        onClick={isSelected ? undefined : onClick}
      >
        <div className="d-flex align-items-center justify-content-between">
          <label className={clsx('custom-control-label mr-24px font-medium font-size-14 text-text-black', { active: isSelected })}>{method.title}</label>
          <div className="d-flex align-items-center gap-12px">
            <AmexIcon />
            <MasterCardIcon />
            <VisaIcon />
          </div>
        </div>

        {isSelected && (
          <>
            <div className="mt-16px payment-modal-options-grid">
              {methods.map((method) => {
                const isActive = method.id === selectedPaymentMethod?.id;
                return (
                  <div
                    className={clsx('p-12px p-md-20px border-radius-12 payment-modal-option-bank', { active: isActive })}
                    onClick={(e) => {
                      e.stopPropagation();
                      return setSelectedPaymentMethod(method);
                    }}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <div className='d-flex align-items-center gap-8px'>
                        {method.id === PaymentMethodsEnum.TbcCard && <TbcBankIcon />}
                        {method.id === PaymentMethodsEnum.BogCard && <BogIcon />}
                        {method.id === PaymentMethodsEnum.OtherBankCard && <OtherBankIcon className="mx-8px" />}
                        <div className="hidden-on-desktop font-medium font-size-12 font-size-md-14" style={{ color: '#272A37' }}>
                          {method.name}
                        </div>
                      </div>
                      <div className={clsx('payment-checkbox', { checked: isActive })}></div>
                    </div>

                    <div className="hidden-on-mobile font-medium font-size-12 font-size-md-14 mt-12px" style={{ color: '#272A37' }}>
                      {method.name}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="mt-16px">
              <Checkbox name="SaveCard" className="mr-24px h-32px font-size-12" checked={saveCard} onChange={onSaveCard} label={langs.NM_SaveCard} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
